import { subjects } from "./options";

export const cleanupLables = (label) => {
    if (!label) return '';
    // let lb = label.replace('_', ' ');
    let lb = label.replace(/_/g, ' ');
    return lb.charAt(0).toUpperCase() + lb.slice(1);
}

export function toLocalISOString(date) {
    try {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    } catch {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();
        const day = today.getDate();
        const dateObject = new Date(`${year}-${month + 1}-${day} ${date}`);
        return toLocalISOString(dateObject);
    }
}

export const formatToDisplayTime = (timeValue) => {
    if (!timeValue) return 'N/A';
    const date = timeValue instanceof Date ? timeValue : new Date(timeValue);
    if (isNaN(date)) return timeValue;
    return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'Asia/Colombo'
    });
};

export const formatToDisplayDate = (dateValue) => {
    if (!dateValue) return 'N/A';
    const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
    if (isNaN(date)) return 'Invalid Date';
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const capitalize = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Compute grade based on marks:
 * < 40   -> W
 * 40-54  -> S
 * 55-64  -> C
 * 65-74  -> B
 * 75+    -> A
 */
export const computedGrade = (marks) => {
  const m = Number(marks);
  if (isNaN(m)) return "-";
  if (m < 40) return "W";
  if (m <= 54) return "S";
  if (m <= 64) return "C";
  if (m <= 74) return "B";
  return "A";
};



export const formatSubjectName = (code) => {
    const subject = subjects.find(sub => sub.code === code);
    return subject ? subject.name : code;
};